.root {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingSm);
  color: var(--paletteBlue0);
  padding: var(--spacingLg) 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.page,
.gap {
  padding: var(---spacingMd);
  height: 34px;
  min-width: 39px;
  background: var(--paletteNeutral1);
  vertical-align: middle;
  color: var(--paletteBlue0);
  border-radius: 0;

  .pageText {
    font-size: 12px;
  }

  &:hover {
    background: var(--paletteBlue1);
    color: var(--paletteWhite0);
    box-shadow: 0 3px 6px var(--paletteNeutral1);
  }

  &.compact {
    height: 24px;

    .pageText {
      font-size: 14px;
    }
  }
}

.low {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

.high {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.current {
  background: var(--paletteBlue1);
  color: var(--paletteWhite0);
}
